import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import { ViewerFragmentCommonProps } from "../ViewerFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import useTranslation from "../../../../../../../packages/locales/translations/util/useTranslation";
import TitledBoxedText from "../../../TitledBoxedText/TitledBoxedText";
import { ListItem } from "../../../SelectListItem/SelectListItem";
import { ItemNoAndTypeWithOrderedDetails } from "@coworker/apprestructured/src/shared/types/item";

export type ArticlesQuantityViewerFragmentConfigProps = {
  // Translation key for the title
  title: string;
  field: string;
  visibility: VisibilityCondition;
};

type ArticlesQuantityViewerFragmentProps = {
  configProps: ArticlesQuantityViewerFragmentConfigProps;
  commonProps: ViewerFragmentCommonProps;
};

interface VisibilityCondition {
  field: string;
  value: any;
  operator: "in";
}

function shouldShowField(
  task: ViewerFragmentCommonProps["task"],
  visibility: VisibilityCondition
): boolean {
  const currentValue = getByPath(task, visibility.field) as ListItem | null;

  if (visibility.operator === "in") {
    return Array.isArray(visibility.value)
      ? visibility.value.includes(currentValue?.value)
      : false;
  }

  return true;
}

export const ArticlesQuantityViewerFragment = ({
  configProps,
  commonProps,
}: ArticlesQuantityViewerFragmentProps) => {
  const { field, title, visibility } = configProps;
  const { task } = commonProps;
  const itemNoAndType = getTypedValue<ItemNoAndTypeWithOrderedDetails[]>(
    getByPath(task, field)
  );
  const { t } = useTranslation();

  if (!shouldShowField(task, visibility)) {
    return null;
  }

  if (isLoading(itemNoAndType) || itemNoAndType.length === 0) {
    return null;
  }

  return <TitledBoxedText title={t(title)} text="Quantity " />;
};
